// extracted by mini-css-extract-plugin
module.exports = {"layout":"AccordionHeader_layout__1LYDK","caretUp":"AccordionHeader_caretUp__3aMNH","caretRight":"AccordionHeader_caretRight__dYQzR","caretDown":"AccordionHeader_caretDown__Ihl3n"};